import { assign, setup, type ActorRefFrom } from 'xstate';
import { responseUnmaskMachine } from './responseUnmask.machine';

export type ResponseUnmaskOwner = {
  actor: ActorRefFrom<typeof responseUnmaskMachine>;
  sourcePath?: string;
};

export const responseUnmaskSessionMachine = setup({
  types: {
    context: {} as { responses: Record<number, ResponseUnmaskOwner> },
    events: {} as { type: 'OPEN_RESPONSE'; responseId: number; sourcePath?: string },
  },
  actors: { consent: responseUnmaskMachine },
}).createMachine({
  id: 'responseUnmaskSession',
  context: { responses: {} },
  on: {
    OPEN_RESPONSE: {
      guard: ({ event }) => Number.isSafeInteger(event.responseId) && event.responseId > 0,
      actions: assign({
        responses: ({ context, event, spawn }) => {
          const existing = context.responses[event.responseId];
          if (existing) return context.responses;
          return {
            ...context.responses,
            [event.responseId]: {
              actor: spawn('consent', { input: { responseId: event.responseId, attached: false } }),
              sourcePath: event.sourcePath,
            },
          };
        },
      }),
    },
  },
});
